"use client";
import { sendGTMEvent } from "@/components/Analytics";
import Newsletter from "@/components/Cards/Newsletter";
import PlayerInPage from "@/components/Player/PlayerInPage";
import Text from "@/components/Text/Text";
import Title from "@/components/Text/Title";
import Triangles from "@/components/Triangles";
import { NewsletterOrange, NewsletterYellowInput } from "@/stories/Newsletter.stories";

export default function WarumAllesEntstandLayout() {
    return (
        <>
            <div className="bg-white flex justify-center">
                <div className="container w-full md:px-20 px-4 pb-24 flex-col justify-center items-center gap-6 inline-flex">
                    <Title
                        hasPreTitle={true}
                        preTitle="Warum alles entstand? ich war auf der suche nach neuen wegen."
                        title="Starke Energiefelder verändern dein Leben"
                        hasSubTitle={false}
                        hasText={true}
                        paddings="px-3 pt-24 lg:px-10"
                        text="Menschen fehlt nicht das Wissen für die Veränderung, sondern die Kraft."
                    />
                    <PlayerInPage
                        videoId="7ce33be74aacde1c261b9db898e7f2a3"
                        thumbnail="/images/thumbnails/warumAllesThumbnail1.jpg"
                    />
                </div>
            </div>
            <div className="bg-white">
                <Triangles backgroundColor="bg-turquoise" buttomToTop={false} />
            </div>
            <div className="bg-turquoise flex justify-center">
                <div className="container w-full lg:py-20 py-10 px-3   flex-col justify-center items-center gap-6 inline-flex">
                    <Text
                        hasPretitle={false}
                        title="Verstehen, um zu helfen"
                        paragraphs={[
                            "Die Entwicklung meiner Arbeitsweise in der Energiefeld-Instandsetzung war notwendig, um den Erfolg meiner Arbeit nicht dem Zufall zu überlassen. Sie muss bis ins kleinste Detail überprüfbar, nachvollziehbar und wiederholbar sein. Mein Antrieb war stets, herauszufinden, wo die genauen Ursachen liegen und woran ich arbeiten muss, damit es einem Menschen besser geht.",
                            "Heute erkenne ich diese Ursachen klar und kann Verletzungen und Überforderungen reparieren. So entdeckte ich die Mechanik des Energiefeldes, die bei jedem Menschen zwar individuell ist in seiner Funktion, aber Gemeinsamkeiten in den Eigenschaften hat.",
                        ]}
                        paddings="px-3 lg:px-74 md:px-20  w-full"
                        leadingText="leading-7 lg:leading-8.5"
                        leading="lg:leading-14 leading-10"
                    />
                </div>
            </div>
            <div className="bg-turquoise">
                <Triangles backgroundColor="bg-pink" buttomToTop={true} />
            </div>
            <div className="bg-pink flex justify-center">
                <div className="container w-full lg:py-30 py-10 px-3  flex-col justify-center items-center gap-6 inline-flex">
                    <Text
                        hasPretitle={false}
                        title="Meine Erfahrung ist, man wartet zu lange"
                        paragraphs={[
                            "In meiner Praxis begegnen mir immer wieder Menschen, die zu lange zögern, bevor sie sich Hilfe holen. Dieses Warten und erfolglose «selber probieren» dauert teilweise jahrelang, weil man gute Methoden falsch anwendet. Sport, Gespräche, Waldspaziergänge, das Fördern der eigenen Intution und ähnliche Ansätze mögen kurzfristig helfen, sind jedoch bei Funktionsstörungen des Energiefeldes selten nachhaltig. Das Leben ist zu kurz, um sich mit unlösbaren Problemen rumzuschlagen.",
                            "Es gibt für viele Bereiche im Leben Spezialisten und ich habe mich auf die Reparatur seelischer Verletzungen und nicht funktionierende Energiefelder spezialisiert. Wie bei einem defekten Auto überlassen wir die Reparatur einem Experten, der genau weiss, wie er es sicher instandsetzen kann, anstatt es selbst zu versuchen.",
                        ]}
                        paddings="px-3 lg:px-74  w-full md:px-20"
                        leadingText="leading-7 lg:leading-8.5"
                        leading="lg:leading-14 leading-10"
                        hasReadMore={true}
                        paragraphSlice={1}
                    />
                </div>
            </div>

            <div className="bg-pink">
                <Triangles backgroundColor="bg-black" buttomToTop={false} />
            </div>
            <div className="bg-black w-full px-3 lg:px-20 py-20 flex-col justify-center items-center gap-6 inline-flex">
                <PlayerInPage
                    videoId="26b53873b2ee63140128c1fa389bc690"
                    thumbnail="/images/thumbnails/warumAllesThumbnail2.jpg"
                />
            </div>
            <div className="bg-black">
                <Triangles backgroundColor="bg-orange" buttomToTop={true} />
            </div>
            <div className="bg-orange flex justify-center">
                <div className="container w-full py-20 lg:py-30 px-3 flex-col justify-center items-center gap-6 inline-flex">
                    <Newsletter
                        backgroundColor={NewsletterOrange.args?.backgroundColor}
                        hasCheckbox={NewsletterOrange.args?.hasCheckbox}
                        hasDescription={NewsletterOrange.args?.hasDescription}
                        hasInput={true}
                        hasSubText={NewsletterOrange.args?.hasSubText}
                        title="Willst du mehr erfahren?"
                        description="Ich lade dich herzlich zu meiner Videosammlung Masterclass ein. Hier dreht sich alles um das faszinierende Thema Energiefelder.  Es ist mir wichtig, dass jeder die Möglichkeit hat, von diesem Wissen zu profitieren."
                        buttonText="HOL DIR DIE  MASTERCLASS"
                        buttonAs="a"
                        href="/de/masterclass#masterclassSection"
                        paddings="lg:px-64 md:px-20"
                        buttonPaddings="px-10 py-4 "
                        onClickButton={() => {
                            sendGTMEvent({
                                event: "cta_click",
                                section_title: "Willst du mehr erfahren?",
                                section_index: "5",
                                cta_text: "HOL DIR DIE  MASTERCLASS",
                                cta_link: `${process.env.NEXT_PUBLIC_URL}/de/masterclass#masterclassSection`,
                            });
                        }}
                    />
                </div>
            </div>
            <div className="bg-orange">
                <Triangles backgroundColor="bg-yellow" buttomToTop={false} />
            </div>

            <div className="bg-yellow flex justify-center">
                <div className="container w-full py-20 lg:px-25 px-3 lg:py-30 flex-col justify-center items-center gap-6 inline-flex">
                    <Newsletter
                        backgroundColor={NewsletterYellowInput.args?.backgroundColor}
                        hasCheckbox={false}
                        hasDescription={NewsletterYellowInput.args?.hasDescription}
                        hasInput={NewsletterYellowInput.args?.hasInput}
                        hasSubText={NewsletterYellowInput.args?.hasSubText}
                        title="Rico’s News abonnieren"
                        buttonText="Abonnieren"
                        checkBoxText="Allgemeine Geschäftsbedingungen und Datenschutzbestimmungen gelesen und akzeptiere sie."
                        inputText="Deine E-Mail-Adresse"
                        placeholderText="Hier eingeben"
                        subText="Abmeldung des Newsletters jederzeit möglich."
                        hasForm={true}
                        buttonPaddings="py-4 px-24 lg:px-[11.5rem]"
                        paddings="lg:px-101 md:px-20"
                        newsletterForm={true}
                    />
                </div>
            </div>
            <div className="bg-yellow ">
                <Triangles backgroundColor="bg-darkGray" buttomToTop={true} />
            </div>
        </>
    );
}
